import logo from '../assets/ebi_blanco.png';

function Header() {
  return (
    <header className="header">
      <div className="header__inner">
        <a href="/" className="header__logo" aria-label="EbiTrade inicio">
          <img src={logo} alt="" className="header__logo-icon" />
          <span className="header__logo-text">EbiTrade</span>
        </a>

        <nav className="header__nav" aria-label="Navegación principal">
          <a href="/#bitacora">Bitácora</a>
          <a href="/#analitica">Analítica</a>
          <a href="/#comunidad">Comunidad</a>
          <a href="/#precios">Precios</a>
        </nav>

        <div className="header__actions">
          <a href="https://app.ebitrade.com" className="header__link">Iniciar sesión</a>
          <a href="https://app.ebitrade.com/register" className="btn btn--primary btn--sm">Comenzar gratis</a>
        </div>
      </div>
    </header>
  );
}

export default Header;
